import React, { useEffect, useRef, useState } from 'react';
import { links } from '../data/dataNav';
import pl_icon from '../images/oferta/pl_icon.svg';
import sample from '../images/oferta/sample.png';
import sample2 from '../images/oferta/oferta-drob.png';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import clsx from 'clsx';
import img1 from '../images/img1.png';
import Select from 'react-select';
import ProductSkeleton from '../components/ProductSkeleton';
import LeftArrowIcon from '../assets/icons/LeftArrowIcon';
import RightArrowIcon from '../assets/icons/RightArrowIcon';
import { IoMdClose } from 'react-icons/io';

const Products = () => {
  const location = useLocation();
  const categoryName = location.pathname.split('/')[2];

  const [isLoading, setIsLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [products, setProducts] = useState([]);

  const [cat1, setCat1] = useState('');

  const cat2Ref = useRef(null);

  const [currentImage, setCurrentImage] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);

  const getProducts = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `http://api.kwiecinscy.com.pl/api/${
          categoryName === 'wedliny' ? 'products' : categoryName
        }?page=${currentPage}&category1=${cat1}`,
      );

      const productsWithImgFormat = res.data.data.map((product) => {
        const img = new Image();
        img.src = product.image;

        const isHorizontal =
          img.naturalWidth > img.naturalHeight ? false : true;

        return { ...product, isHorizontal };
      });

      setProducts(productsWithImgFormat);
      setTotalPages(res.data.last_page);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const categoryTitle = () => {
    switch (categoryName) {
      case 'wedliny':
        return 'Wędliny';
      case 'wieprzowina':
        return 'Mięso wieprzowe';
      case 'drob':
        return 'Drób';
      case 'ofertagastronomiczna':
        return 'Oferta gastronomiczna';
      case 'ofertaspecjalna':
        return 'Oferta specjalna';
      default:
        return 'Wędliny';
    }
  };

  const categoryOneOptions = [
    { value: 'wieprzowe', label: 'Szynki wieprzowe' },
    { value: 'laskowe', label: 'Laskowe' },
    { value: 'blokowe', label: 'Blokowe' },
    { value: 'produkty-garmazeryjne', label: 'Produkty garmażeryjne' },
    { value: 'podsuszane-i-wedzonki', label: 'Podsuszane i wędzonki' },
    { value: 'wyroby-podrobowe', label: 'Wyroby podrobowe' },
    { value: 'dziczyzna', label: 'Dziczyzna' },
    { value: 'wyroby-drobiowe', label: 'Wyroby drobiowe' },
    { value: 'inne', label: 'Inne' },
  ];

  const handleCategoryOneChange = (selectedOption) => {
    if (selectedOption === null) {
      setCat1('');
    } else {
      setCat1(selectedOption.value);
    }
    setCurrentPage(1);
  };

  const handlePrevPage = () => {
    if (currentPage <= 1) return;
    setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage >= totalPages) return;
    setCurrentPage(currentPage + 1);
  };

  const handleZoomImage = (image) => {
    document.body.style.overflow = 'hidden';
    setIsModalVisible(true);
    setCurrentImage(image);
  };

  const handleCloseModal = () => {
    setIsModalVisible(false);
    document.body.style.overflow = 'auto';
  };

  useEffect(() => {
    getProducts();
  }, [currentPage, cat1]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  return (
    <>
      {isModalVisible ? (
        <div className="fixed top-0 bg-slate-700/90 w-screen h-screen z-[1000] ">
          <div className="m-auto w-full h-full flex justify-center items-center relative">
            <IoMdClose
              onClick={handleCloseModal}
              className="absolute top-6 right-6 scale-[2.2] md:top-10 md:right-10 md:scale-[3] text-white cursor-pointer"
            />
            <img
              src={currentImage}
              alt="zdjęcie"
              className="m-auto max-w-[80%] max-h-[80%] "
            />
          </div>
        </div>
      ) : null}
      <section className="products-section flex flex-col gap-8">
        <div className="border-b border-[#0e3a1b] w-[calc(100%-20px)] mx-auto pb-2">
          <h1 className="text-center text-[#0e3a1b]">{categoryTitle()}</h1>
        </div>
        {categoryName === 'wedliny' ? (
          <div className="container flex flex-col md:flex-row gap-4 items-center">
            <span className="text-lg font-bold">Filtrowanie</span>
            <div className="flex gap-4 flex-col sm:flex-row">
              <Select
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 0,
                  colors: {
                    ...theme.colors,
                    primary25: '#f5dfdf',
                    primary: 'black',
                  },
                })}
                className="w-60"
                isSearchable={false}
                isClearable={true}
                placeholder="Kategoria wędliny"
                options={categoryOneOptions}
                onChange={handleCategoryOneChange}
              />
            </div>
          </div>
        ) : null}
        {isLoading ? (
          <ProductSkeleton />
        ) : products.length === 0 ? (
          <span className="text-green-800 text-lg flex justify-center items-center min-h-[calc(100dvh-450px)] underline px-4">
            Brak produktów spełniających wynik filtrowania
          </span>
        ) : (
          <div className="products-container container min-h-[calc(100dvh-450px)]">
            {products.map((product) => {
              return (
                <article
                  className={clsx(
                    'flex h-[560px] w-full hover:bg-slate-50 transition-all',
                    'flex-col',
                  )}
                >
                  <img
                    src={product.image}
                    onClick={() => handleZoomImage(product.image)}
                    alt={product.name}
                    className={clsx(
                      'object-cover',
                      'w-full h-auto max-h-[50%] cursor-zoom-in',
                      // product.isHorizontal
                      //   ? 'min-h-full min-w-[50%] max-w-[50%] object-contain'
                      // 'w-full h-auto max-h-[50%]',
                    )}
                  />
                  <div className="p-2 overflow-auto flex flex-col gap-4">
                    <h3 className="text-red-800">{product.name}</h3>
                    <p className="text-base">{product.description}</p>
                    <div>
                      <b>Masa netto:</b>
                      <span className="flex gap-2 items-center">
                        {product.weight} g
                      </span>
                    </div>
                    <div>
                      <b>Pochodzenie mięsa:</b>
                      <span className="flex gap-2 items-center text-red-700">
                        <img src={pl_icon} alt="poland flag" />{' '}
                        <span>POLSKA</span>
                      </span>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        )}
        <div className="container flex justify-center gap-4 pt-auto">
          <button onClick={handlePrevPage}>
            <LeftArrowIcon />
          </button>
          {[...Array(totalPages)].map((_, i) => {
            return (
              <button
                className={clsx(
                  'text-xl px-2 rounded-lg text-black hidden md:flex',
                  currentPage === i + 1 && 'bg-[#fcf0f0] text-[#f44343]',
                )}
                onClick={() => setCurrentPage(i + 1)}
              >
                {i + 1}
              </button>
            );
          })}
          <button onClick={handleNextPage}>
            <RightArrowIcon />
          </button>
        </div>
      </section>
    </>
  );
};

export default Products;
